import { useSelector } from 'react-redux';
import { requestSelectors } from 'src/store/requests/selectors';
import { useIsMobile } from 'src/hooks/use-is-mobile';
import { useTypeDisplayedSpinner } from 'src/hooks/use-type-displayed-spinner';
import { TypesOfSpinner } from 'src/typings/types-of-spinner';
import { pathList } from 'src/route-list';
import { useLocation } from 'react-router-dom';

export const useAppPageLogo = () => {
  const mainLogo: any = useSelector(requestSelectors.app.getMainLogo);
  const mainLogoMobile: any = useSelector(requestSelectors.app.getMainLogoMobile);
  const { isMobileScreen } = useIsMobile();
  const { getSelectedViewId } = useTypeDisplayedSpinner();
  const location = useLocation();
  const useDesktopLogoMap: { [key: string]: boolean } = {
    [TypesOfSpinner.viewSpinner]: false,
    [TypesOfSpinner.viewLayouts]: true,
    [TypesOfSpinner.viewFloors]: true,
    [TypesOfSpinner.view2d]: true,
    [TypesOfSpinner.viewInMap]: true,
  };
  const useDesktopLogoOnPage: boolean = location.pathname === pathList.compare || useDesktopLogoMap[getSelectedViewId];
  const logoSrc = (isMobileScreen && !useDesktopLogoOnPage) ? mainLogoMobile : mainLogo;
  return {
    mainLogo,
    mainLogoMobile,
    logoSrc,
  };
};
